<template>
  <div class="m-3">
    <b-button variant="info" class="mb-3" v-if="podeCriar" @click="novo">
      <i class="fa-solid fa-plus mr-2"></i>
      Inserir
    </b-button>

    <tabela-padrao
      sem-selecionar-todos
      v-model="tabela.dados"
      :colunas="tabela.colunas"
      sem-paginacao
      ref="tabela"
    >
      <template #cell(acoes)="linha">
        <div>
          <tabela-padrao-acoes
            v-if="!linha.item.vinculadoARelatorioEtapa && !aprovada"
            @editar="editar(linha.item)"
            @excluir="excluir(linha.item.id)"
            :pode-editar="podeEditar && (TelaExecAssociada ? linha.item.executora : true)"
            :pode-excluir="
              podeExcluir && (TelaExecAssociada ? linha.item.executora : true)
            "
          />
          <b-button
            @click="abrirEtapa(linha.item.cronogramaEtapa)"
            variant="outline-primary"
            v-if="linha.item.vinculadoARelatorioEtapa"
          >
            Vinculado à etapa {{ linha.item.numeroEtapa }}.
          </b-button>
        </div>
      </template>
    </tabela-padrao>

    <modal-entregavel ref="modal-entregavel" @buscar="buscar" />
    <modal-cronograma ref="modal-cronograma-etapa" @buscar="buscar" />
  </div>
</template>
<script>
import PropostaService from "@/common/services/proposta/proposta.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

import helpers from "@/common/utils/helpers";
import cloneDeep from "lodash/cloneDeep";

import ModalEntregavel from "./modal";
import ModalCronograma from "../cronograma_etapa/modal.vue";

export default {
  name: "PropostaEntregaveis",
  mixins: [AlertasMixin],
  props: {
    propostaId: {
      required: true,
    },
    propostaOriginalId: {
      required: true,
    },
    duracao: {
      required: true,
    },
    aprovada: {
      type: Boolean,
      default: false,
    },
    endpoint: {
      type: String,
      default: "Proposta",
    },
  },
  components: {
    ModalEntregavel,
    ModalCronograma,
  },
  data: () => ({
    tabela: {
      dados: [],
      colunas: [
        {
          key: "tipo",
          label: "Tipo",
          formatter: (value, key, item) => {
            if (value)
              return item.vinculadoARelatorioEtapa
                ? `Relatório de etapa`
                : helpers.getEnum(value)
                ? `${helpers.getEnum(value).text}`
                : value;
          },
        },
        {
          key: "subtipo",
          label: "Produto",
          formatter: (value, key, item) => {
            if (item.vinculadoARelatorioEtapa) return item.relatorioEtapa.titulo;

            let tipoEntregavel = helpers.getTipoEntregavel(item.tipo.trim());
            let texto = tipoEntregavel.text;
            if (tipoEntregavel.value != tipoEntregavel.subtipo)
              texto = `${helpers.getEnum(tipoEntregavel.subtipo).text}`;
            return `${texto} ${item.sequencial}`;
          },
        },
        {
          key: "prazo",
          label: "Previsão de entrega",

          formatter: (value, key, item) => {
            return (
              "Mês " +
              (item.vinculadoARelatorioEtapa ? item.relatorioEtapa.mesFinal : value)
            );
          },
        },
        { key: "acoes", label: "Ações" },
      ],
    },

    form: [
      {
        propostaId: null,
        tipo: null,
        subtipo: null,
        valor: 1,
        prazo: 0,
        sequencial: null,
      },
    ],
  }),
  methods: {
    verificacao: function (item) {
      return (
        !item.vinculadoARelatorioEtapa && (this.TelaExecAssociada ? item.executora : true)
      );
    },

    montar() {
      this.buscar();
    },
    buscar: function () {
      this.$store.dispatch(START_LOADING);
      PropostaService.buscarEntregavel(this.propostaOriginalId)
        .then((response) => {
          this.tabela.dados = response.data.data.sort((a, b) => {
            return (
              (a.vinculadoARelatorioEtapa ? a.relatorioEtapa.mesFinal : a.prazo) -
              (b.vinculadoARelatorioEtapa ? b.relatorioEtapa.mesFinal : b.prazo)
            );
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    novo: function () {
      this.$refs["modal-entregavel"].abrirModal(
        this.duracao,
        this.propostaId,
        this.tabela.dados
      );
    },
    editar: function (item) {
      let form = [cloneDeep(item)];
      form = form.map((el) => {
        el.entregavelId = el.id;
        return el;
      });
      this.$refs["modal-entregavel"].abrirModal(
        this.duracao,
        this.propostaId,
        this.tabela.dados,
        form
      );
    },
    excluir: function (id) {
      this.confirmar("Aviso", "Deseja remover o entregável?").then((confirmado) => {
        if (!confirmado) return;

        let form = {
          entregavelId: id,
          propostaId: this.propostaId,
        };

        this.$store.dispatch(START_LOADING);

        PropostaService.removerEntregavel(form)
          .then(() => {
            this.alertaSucesso(`Entregável excluído com sucesso!`).then(() => {
              this.montar();
            });
          })
          .catch(() => {
            this.alertaErro("Erro ao excluir entregável");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    abrirEtapa: function (form) {
      form.cronogramaEtapaId = form.id;
      this.$refs["modal-cronograma-etapa"].abrirModal(
        this.duracao,
        this.propostaId,
        null,
        this.endpoint,
        form,
        this.podeExcluirEtapa,
        this.podeEditarEtapa
      );
    },
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("PropostaEntregaveis");
    },
    permissaoCronogramaEtapa() {
      return this.$store.getters["app/retornaPermissao"]("PropostaCronogramaEtapas");
    },
    podeManipular: function () {
      return !this.TelaProponente && !this.TelaProponenteCooperada;
    },
    podeCriar: function () {
      return this.podeManipular && this.permissao.c;
    },
    podeEditar: function () {
      return this.podeManipular && this.permissao.u;
    },
    podeExcluir: function () {
      return this.podeManipular && this.permissao.d;
    },
    podeExcluirEtapa: function () {
      return (
        !this.aprovada &&
        !this.TelaProponente &&
        !this.TelaProponenteCooperada &&
        !this.TelaExecAssociada &&
        this.permissao.d
      );
    },
    podeEditarEtapa: function () {
      return (
        !this.aprovada &&
        !this.TelaProponente &&
        !this.TelaProponenteCooperada &&
        this.permissaoCronogramaEtapa.u
      );
    },
    TelaProponente() {
      return this.endpoint == "PropostaEmpresaProponente";
    },
    TelaExecAssociada() {
      return this.endpoint == "PropostaEmpresaExecutora";
    },
    TelaProponenteCooperada() {
      return this.endpoint == "PropostaEmpresaCooperada";
    },
  },
};
</script>
<style lang=""></style>
